import { hasCubeAiSeat } from "@Helpers/cubeAi";

/**
 * Where CUBE AI (the header icon and the panel Router.tsx mounts) exists: pre-production
 * environments only, and never on the full-page chat itself, on share links — a logged-in user
 * opening one still gets the RECIPIENT experience (QA r3 3b) — or on PDF-export renders.
 */
export function isCubeAiAvailable(pathname: string): boolean {
  const env = process.env.REACT_APP_ENV;
  if (!env || !["qa", "development", "staging"].includes(env)) return false;
  return !pathname.startsWith("/ai/chat") && !pathname.startsWith("/share/") && !pathname.includes("pdfExport");
}

/**
 * Whether THIS user may see the chatbot launcher (CP-1361): on portals that sell seats, only a
 * CUBE AI Full Seat holder gets it. Portals that do not sell seats (enterprise / on-prem) are not
 * gated — the server's `checkAiAccess` treats them the same way. The remaining rules (product seat,
 * subscription live, cycle and session limits) are the server's: the panel shows its refusal inline,
 * and Profile ▸ AI Usage explains it.
 */
export function isCubeAiEntitled(
  portal: { newSignUpFlow?: boolean | null | undefined },
  user: { portal?: { seat?: unknown } | undefined },
): boolean {
  if (!portal.newSignUpFlow) return true;
  return hasCubeAiSeat(user.portal?.seat);
}
